import textFieldComponent from "@/components/formBuilder/addons/TextAreaField.vue";
export const schema = {
  /* section_head_1: {
    step: 1,
    fieldType: "label_field",
    label: "Exposure of home to flooding and previous flood impact",
    type: "section-head",
    wrapperStyle: {
      class: "section-header",
      style: {
      },
    },
    fieldStyle: {},
    validations: {},
  },
  section_head_description: {
    step: 1,
    fieldType: "label_field",
    label:
      "Answer a few questions about the location of your home, the characteristics of the surrounding area and your experience with previous flood events to help predict how well your home can withstand a major flood event.",
    type: "desc",
    wrapperStyle: {
      class: "",
      style: {},
    },
    fieldStyle: {},
    validations: {},
  }, */
  flood_section_description: {
    step: 1,
    fieldType: "section_desc_field",
    description: `
		<div class="sectionX-title">Exposure of Home to Flooding and Previous Flood Impact</div>
    <p>
    Answer a few questions about the location of your home, the characteristics of the surrounding area and your experience with previous flood events to help predict how well your home can withstand a major, <a href="#" helper-id="F9012">100-year flood</a> event.
    </p>
		`,
    wrapperStyle: {},
    fieldStyle: {},
    expandable: false,
    validations: {},
  },
  area_prone_flooding: {
    step: 1,
    cardDefaults: " ",
    fieldType: "custom_group_radio_field",
    questionNum: 1,
    // fieldType: 'text',
    label: "Do you live in an area that is known to be prone to flooding?",
    placeholder: "",
    helperText: "",
    section: "exposure",
    value: "",
    rFeature: "roof",
    answer: ["yes"],
    options: [
      {
        text: "Yes",
        value: "yes",
      },
      {
        text: "No",
        value: "no",
      },
    ],
    // invalid: true,
    wrapperStyle: {
      class: "negative-margins-no-top-no-bottom",
    },
    fieldStyle: {},
    validations: {},
  },
  river_overflowed_christmas_trough: {
    step: 1,
    cardDefaults: " ",
    fieldType: "custom_group_radio_field",
    questionNum: 2,
    label: "Do you live close to a river that overflowed during the 2013 Christmas Eve Trough?",
    placeholder: "",
    helperText: "",
    section: "exposure",
    value: "",

    options: [
      {
        text: "Yes",
        value: "yes",
      },
      {
        text: "No",
        value: "no",
      },
    ],
    // invalid: true,
    wrapperStyle: {
      class: "negative-margins-no-top-no-bottom",
    },
    fieldStyle: {},
    validations: {},
  },
  drains_overflow_trough: {
    step: 1,
    fieldType: "custom_group_radio_field",
    questionNum: 3,
    cardDefaults: " ",
    label: "Did the drains in your community overflow during the 2013 Christmas Eve Trough?",
    placeholder: "",
    helperText: "",
    value: "",
    section: "exposure",
    options: [
      {
        text: "Yes",
        value: "yes",
      },
      {
        text: "No",
        value: "no",
      },
    ],
    // invalid: true,
    wrapperStyle: {
      class: "negative-margins-no-top-no-bottom",
    },
    fieldStyle: {},
    validations: {},
  },
  experience_flooding_trough: {
    step: 1,
    fieldType: "custom_group_radio_field",
    questionNum: 4,
    label: `Did you experience flooding at your home during the 2013 Christmas Eve Trough?`,
    placeholder: "",
    helperText: "",
    cardDefaults: " ",
    description: "Select 'Not applicable' if the 2013 Christmas Eve Trough occurred prior to your home's construction or if you lived somewhere else at the time.",
    value: "",
    section: "exposure",
    options: [
      {
        text: "Yes",
        value: "yes",
      },
      {
        text: "No",
        value: "no",
      },
      {
        text: "Not Applicable",
        value: "na",
      },
    ],
    // invalid: true,
    wrapperStyle: {
      class: "negative-margins-no-top-no-bottom",
    },
    fieldStyle: {},
    gridStyle: {
      grid: "col s6",
    },
    validations: {},
  },

  experience_flooding_trough_impact_level: {
    step: 1,
    fieldType: "custom_group_radio_field",
    questionNum: 5,
    label: ` If you experienced flooding in the 2013 Christmas Eve Trough, based on the definitions provided in the <a href="#" helper-id="C002"> Expected Impact Level Chart</a>, how serious was the impact?`,
    //label: "How serious was the impact?",
    description: /* html */ `
      <ul class="criteria-list ">
        <li><b>Minor:</b> No Significant Damage. The structure is useable and can be occupied. Repairs required are minimal.</li>
        <li><b>Moderate:</b> Moderate Damage. The structure is useable and can be occupied after urgent temporary measures are taken. The owner will probably need assistance with repairs.</li>
        <li><b>Major:</b> Major damage. The structure is not usable and cannot be occupied until after repairs are made.</li>
        <li><b>Extreme:</b> Destroyed. The structure is not useable. The structure must be rebuilt or requires major structural repairs</li>
      </ul>
    `,
    // expandList: [],
    placeholder: "",
    cardDefaults: " ",
    helperText: "",
    section: "exposure",
    value: "",
    condition: {
      key: "experience_flooding_trough",
      value: "yes",
    },

    options: [
      {
        text: "Minor",
        value: "minor",
      },
      {
        text: "Moderate",
        value: "moderate",
      },
      {
        text: "Major",
        value: "major",
      },
      {
        text: "Extreme",
        value: "extreme",
      },
    ],
    // invalid: true,
    wrapperStyle: {
      class: "negative-margins-no-top-no-bottom",
    },
    fieldStyle: {},
    gridStyle: {
      grid: "col s6",
    },
    validations: {},
  },
  experienced_flooding_water_home: {
    step: 1,
    fieldType: "custom_group_checkbox_field",
    questionNum: 6,
    showQuestionNum: true,
    label: "If you experienced flooding, how did the water get inside your home? (Select all that apply.)",
    placeholder: "",
    customMod: "checkboxes",
    helperText: "",
    value: [],
    answer: "isCondition",
    section: "exposure",
    condition: {
      key: "experience_flooding_trough",
      // operation: {
      //     operator: '>',
      //     length: 0
      // },
      value: "yes",
    },
    options: [
      {
        text: "Water seeping under doors",
        value: "seeping_under_door",
      },
      {
        text: "Water seeping through leaky windows",
        value: "seeping_through_leaky_windows",
      },
      {
        text: "Water flowing through leaky roof",
        value: "flowing_through_leakey_roof",
      },
      {
        text: "Fast-flowing water/mud breaking through doors",
        value: "water_mud_through_doors",
      },
      {
        text: "Fast-flowing water/mud breaking through windows",
        value: "water_mud_through_windows",
      },
      {
        text: "Rising water/mud level breaking through doors",
        value: "rising_water_mud_through_doors",
      },
      {
        text: "Rising water/mud level breaking through windows",
        value: "rising_water_mud_through_windows",
      },
      {
        text: "Other - specify",
        value: "other_specify",
      },
    ],
    wrapperStyle: {
      class: "negative-margins-no-top-no-bottom",
    },
    gridStyle: {
      grid: "col s12",
    },
    additionalKey: "experienced_flooding_water_home_other_specify",
    componentLoader: textFieldComponent,
    additionalCondition: "other_specify",
    hasCondition: true,
    fieldStyle: {},
    validations: {},
  },
  experienced_flooding_water_home_other: {
    step: 1,
    fieldType: "input_field",
    type: "textarea",
    label: /* html */ `
    <div style="display:flex">
    <div class="left" style="font-size: 18px; line-height: 24px; margin-right: 6px;" >7.</div>
    <div style="font-size: 18px; transform: translateY(-2px);">
      What was the root cause of flooding at your home in the 2013 Christmas Eve Trough or any other recent event that resulted in flooding?
    </div>
    </div>
    `,
    placeholder: "",
    description: /* html */ `
      <div class="card z-depth-0 grey lighten-3">
        <div class="card-content">
          Please explain in your own words. Examples may include things like a nearby river that overflowed its banks, a blockage in the drainage system close to your home, the location of your home in a low point where water from the community pools/collects, etc.
        </div>
      </div>
    `,
    helperText: "",
    section: "exposure",
    value: "",
    questionNum: 7,
    showQuestionNum: true,
    wrapperStyle: {
      class: "col s12",
    },
    gridStyle: {
      grid: "col s12",
    },
    fieldStyle: {},
    validations: {},
  },
  section_one_complete: {
    step: 1,
    fieldType: "complete_field",
    sectionName: "",
    validations: {},
  },
  section_head_2: {
    fieldType: "section_desc_field",
    description: `
		<div class="sectionX-title">Resilience of Home to Flooding</div>
    <p>Good news! Your home may have certain features that can 1) help prevent floodwater from getting inside during a flood event and 2) reduce the impact of floodwater that may get inside your home. Use this checkbox assessment to tell us which features are present at your home.</p>
		`,
    step: 2,
    wrapperStyle: {
      class: "",
      style: {},
    },
    fieldStyle: {},
    validations: {},
  },
  /*
  section_2_description: {
    step: 2,
    fieldType: "label_field",
    label: `Good news! Your home may have certain features that can 1) help prevent flood water from getting inside during a flood event and 2) reduce the impact of flood water that may get inside your home. Use this checkbox assessment to tell us which features are present at your home.`,

    type: "desc",
    wrapperStyle: {
      class: "",
      style: {
      },
    },
    fieldStyle: {},
    validations: {},
  }, */
  features_prevent_flooding_home: {
    step: 2,
    fieldType: "custom_group_checkbox_field",
    questionNum: 7,
    label: "1. Which of the following positive features that can prevent floodwater from getting inside does your house have?",
    placeholder: "",
    helperText: "",
    customMod: "checkboxes",
    section: "vulnerability",
    value: [],
    options: [
      {
        text:
          'Good drainage system (such as <a href="#" helper-id="D423" style="margin:0 0px;">French Drains</a>, <a href="#" helper-id="D447" style="margin:0 0px;">Trench Drains</a>, <a href="#" helper-id="D534">Swales</a>, Retention Ponds etc.) around the house that is connected to the drains in your surrounding community. You can easily find images of all of these drainage features online.',
        value: "good_drainage_system",
      },
      {
        text:
          '<a href="#" helper-id="D128">Gutters</a> to collect rainwater combined with <a href="#" helper-id="D598">downspouts/downpipes</a> to guide collected water into water tanks (ideal) or away from the house',
        value: "gutters_collect_water",
      },
      {
        text:
          'Trees and grasses known to slow and control water runoff (such as Mango trees and  <a href="#" helper-id="D9699">Vetiver grass</a>) planted in areas where rainwater flows over the land and in areas prone to erosion. Grasses are most effective when planted in dense/thick hedges. Search for images of Vetiver grass <a target="_blank" href="https://www.vetiver.org/">here!</a>',
        value: "trees_grass",
      },
      {
        text: "Floors in the house are higher/more elevated than the level of floodwater experienced outside the house in previous flood events",
        value: "floors_house",
      },
      {
        text: "Intact roof with no leaks",
        value: "intact_roof",
      },
      {
        text: "Secondary water barrier (such as Ice and Water Shield) present between the roof sheathing/deck and the roof covering (e.g. galvanized/galvalume sheets)",
        value: "second_water_barrier",
      },
      {
        text: `<a helper-id="D1002" href="#">Filler blocks</a> present between flashings (e.g. hip caps, ridge caps, wall flashing) and U-panel or corrugated galvalume sheets to prevent the ingress of wind-driven rain onto roof sheathing.`,
        value: `filler_blocks`,
      },
      {
        text: "Windows that are properly sealed and can be properly closed",
        value: "windows_properly_sealed",
      },
      {
        text: "Drain pipes for greywater (e.g. from kitchen sinks, showers, laundries) fitted with non-return or backflow valves to prevent stormwater ingress/inflow from surrounding drainage system",
        value: "drains_pipes_greywater",
      },
    ],
    wrapperStyle: {
      class: "",
    },
    gridStyle: {
      grid: "col s12",
    },
    fieldStyle: {},
    validations: {},
  },
  features_reduce_impact_flood_home: {
    step: 2,
    fieldType: "custom_group_checkbox_field",
    questionNum: 8,
    customMod: "checkboxes",
    label: "2. Which of the following positive features that can reduce the impact of floodwater inside does your house have?",
    placeholder: "",
    helperText: "",
    section: "vulnerability",
    value: [],
    options: [
      {
        //text: 'Water-resistant flooring (e.g. bare concrete, ceramic tiles, vinyl tiles, <a href="#" helper-id="D316">preservative treated wood</a> or <a href="#" helper-id="D602">decay-resistant wood</a>)',
        text:
          'Water-resistant flooring (e.g. sealed, treated concrete floor; <a href="#" helper-id="D4912"> ceramic </a> or porcelain tiles; <a href="#" helper-id="D0123">vinyl tiles</a>; wooden floor with waterproof sealant)',
        value: "water_resistant_flooring",
      },
      {
        text: `Water-resistant walls (e.g. concrete walls with mildew-resistant or water-resistant/proof paint or hardwood walls with waterproof sealant). Note: <a href="#" helper-id="D711">Plywood</a>, <a href="#" helper-id="D556">sheetrock</a> and <a href="#" helper-id="D91722">cement board </a> walls are not considered water resistant.`,
        value: "water_resistant_walls",
      },
      {
        text: `Ventilation, air conditioning and other service equipment piping and ducts located above the elevation of floodwater experienced in your home during the 2013 Christmas Eve Trough (100-year flood)`,
        value: "new_replacement_electrical_equipment",
      },
      {
        text:
          "Electrical equipment and fixtures (wiring and outlets, switches, junction boxes and panels) located above the elevation of floodwater experienced in your home during the 2013 Christmas Eve Trough (100-year flood)",
        value: "electrical_wiring",
      },
      {
        text: 'Electrical cables encased in water-tight <a href="#" helper-id="D41">conduits</a> to protect them',
        value: "electrical_cables_encased",
      },
      {
        text: "Carpeting or other finishes that absorb water is avoided",
        value: "carpeting",
      },
    ],
    wrapperStyle: {
      class: "",
    },
    gridStyle: {
      grid: "col s12",
    },
    fieldStyle: {},
    validations: {},
  },

  section_two_complete: {
    step: 2,
    fieldType: "complete_field",
    sectionName: "",
    validations: {},
  },
};

export const impactLevelGenerator = (schema, values) => {
  let experienceFloodAns = values.experience_flooding_trough;
  let floodImpactAns = values.experience_flooding_trough_impact_level;
  let experienceFloodingAns = values.experienced_flooding_water_home;

  const nonImpactLevelChecker = () => {
    return experienceFloodAns !== "yes" ? true : false;
  };

  const minorImpactLevelChecker = () => {
    if (!experienceFloodingAns) return false;
    if (
      experienceFloodAns === "yes" &&
      floodImpactAns === "minor" &&
      experienceFloodingAns.length < 3 &&
      experienceFloodingAns.every((item) => item === "seeping_under_door" || item === "seeping_through_leaky_windows")
    )
      return true;
    return false;
  };
  const moderateImpactLevelChecker = () => {
    if (!experienceFloodingAns) return false;
    return experienceFloodAns === "yes" &&
      floodImpactAns === "moderate" &&
      experienceFloodingAns.every((item) => item === "seeping_under_door" || item === "seeping_through_leaky_windows" || item === "flowing_through_leakey_roof")
      ? true
      : false;
  };

  const majorImpactLevelChecker = () => {
    return experienceFloodAns === "yes" && floodImpactAns === "major" ? true : false;
  };
  const extremeImpactLevelChecker = () => {
    return experienceFloodAns === "yes" && floodImpactAns === "extreme" ? true : false;
  };

  if (nonImpactLevelChecker()) {
    return "None";
  } else if (minorImpactLevelChecker()) {
    return "Minor";
  } else if (moderateImpactLevelChecker()) {
    return "Moderate";
  } else if (majorImpactLevelChecker()) {
    return "Major";
  } else {
    return "Extreme";
    // if (extremeImpactLevelChecker())
    // if (floodImpactAns.length <= 0) {
    //     return 'Minor'
    // }
    // return 'Moderate'
  }
};
